import { xfetch } from '../../lib/xfetch';
import type { Survey, SurveyStatus } from '../../survey';
import { getApiBase, REQUEST_TIMEOUT } from '../config';
import { ApiError, ResponseSuccessFieldError, type BaseResponseData } from '../types';

export type SurveyStatusToSend = {
  id: NonNullable<Survey['formVersionId']>;
  status: SurveyStatus; // сохраняется в mp_status в таблице survey.xs_cm
  cm_id: NonNullable<Survey['cmId']>;
};

export class SurveyStatusSendingError extends ApiError {
  constructor(...args: ConstructorParameters<typeof ApiError>) {
    super(...args);
  }
}

export const sendSurveyStatus = async (status: SurveyStatusToSend, beacon = true) => {
  try {
    const data = await xfetch<BaseResponseData>(`${getApiBase()}/saveForm`, {
      timeout: REQUEST_TIMEOUT,
      data: status,
      beacon
    });

    if (!data.success) {
      throw new ResponseSuccessFieldError();
    }

    return data;
  } catch (err) {
    throw new SurveyStatusSendingError(undefined, { cause: err });
  }
};
